import React from "react";
import { useSelector } from "react-redux";

import { ConfigLink } from "../../../configLink/ConfigLink";
import { getLogoLink } from "../../../../store/config";
import { useIntlTranslate } from "../../../../hooks";
import { Logo } from "../logo/Logo";

import "./HeaderLogo.scss";

export const HeaderLogo = () => {
  const logoLink = useSelector(getLogoLink);
  const translate = useIntlTranslate();

  return (
    <ConfigLink
      to={logoLink}
      className="header-logo"
      aria-label={translate("aria_go_to_home")}
    >
      <Logo />
    </ConfigLink>
  );
};

export const WizardHeaderLogo = () => <Logo />;
